import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { IncidentFrameworkDimensionModel } from "../models/incident-framework-dimension.model";

@Injectable({
    providedIn: "root",
})
export class IncidentFrameworkDimensionService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/framework-dimensions`;

    public getAll(): Observable<IncidentFrameworkDimensionModel[]> {
        return this.httpClient.get<IncidentFrameworkDimensionModel[]>(this.baseUrl);
    }

    public getAllByIncident(incidentId: string): Observable<IncidentFrameworkDimensionModel[]> {
        if (!incidentId) {
            return this.httpClient.get<IncidentFrameworkDimensionModel[]>(this.baseUrl);
        } else {
            return this.httpClient.get<IncidentFrameworkDimensionModel[]>(
                `${this.baseUrl}/incident/${incidentId}`
            );
        }
    }
}
